import { set, get } from 'lodash';

import {
  actions,
  status as statusConstants,
  state as stateConstants
} from 'src/constants';

import * as reducerConstants from './constants';

const INITIAL_STATE = {};

const asyncActionTypes = [
  actions.ACTION_UPLOAD,
];

const syncActionTypes = [
  actions.REMOVE_FILE_DATA
];

const statuses = [
  statusConstants.PENDING,
  statusConstants.SUCCESS,
  statusConstants.ERROR,
  undefined
];

export const actionTypeRegExp = new RegExp(
  '@([A-Z0-9_]+)/' +
  `(${asyncActionTypes.join('|')})` +
  '_([A-Z_]+)_' +
  `(${statuses.join('|')})`
);

const syncActionTypeRegExp = new RegExp(
  '@([A-Z0-9_]+)/' +
  `(${syncActionTypes.join('|')})`
);

export default (state = INITIAL_STATE, action) => {
  const { type, response, payload = {}, error, fileId, dataPath } = action;

  if (!type) {
    return state;
  }

  const asyncMatchResult = type.match(actionTypeRegExp);
  const syncMatchResult = type.match(syncActionTypeRegExp);

  if (!asyncMatchResult && !syncMatchResult) {
    return state;
  }

  const matchResult = asyncMatchResult || syncMatchResult;

  const [, , actionType, identifier, status] = matchResult;

  const uniqueIdentifier = `${identifier ||
    stateConstants.IDENTIFIER_TYPE_ITEM.toUpperCase()}-${payload.id || fileId}`;
  const nextState = { ...state };

  if (actionType === actions.REMOVE_FILE_DATA) {
    if (!fileId) {
      return {};
    }

    delete nextState[uniqueIdentifier];

    return nextState;
  }

  const storePath = [uniqueIdentifier];

  if (status === statusConstants.PENDING) {
    return set(nextState, storePath, {
      [reducerConstants.PROPERTY_STATUS]: statusConstants.PENDING,
      ...payload,
      [reducerConstants.PROPERTY_IS_UPLOADING]: true,
      [reducerConstants.PROPERTY_UPLOADED]: false,
      [reducerConstants.PROPERTY_ERROR]: undefined
    });
  }

  if (status === statusConstants.SUCCESS) {
    // this condition is used when the file was removed before receiving a response from BE
    if (!nextState[uniqueIdentifier]) {
      return nextState;
    }

    return set(nextState, storePath, {
      [reducerConstants.PROPERTY_STATUS]: statusConstants.SUCCESS,
      ...payload,
      [reducerConstants.PROPERTY_DATA]: get(response, dataPath) || response,
      [reducerConstants.PROPERTY_IS_UPLOADING]: false,
      [reducerConstants.PROPERTY_UPLOADED]: true,
      [reducerConstants.PROPERTY_ERROR]: undefined
    });
  }

  if (status === statusConstants.ERROR) {
    if (!nextState[uniqueIdentifier]) {
      return nextState;
    }

    return set(nextState, storePath, {
      [reducerConstants.PROPERTY_STATUS]: statusConstants.ERROR,
      ...payload,
      [reducerConstants.PROPERTY_IS_UPLOADING]: false,
      [reducerConstants.PROPERTY_UPLOADED]: true,
      [reducerConstants.PROPERTY_ERROR]: error
    });
  }

  return state;
};
